export const CREATE_PROGRAM_REGION = `
  mutation createProgramRegion($input: CreateProgramRegionInput!, $tenant_id: Int!) {
    createProgramRegion(input: $input, tenant_id: $tenant_id) {
      name
      region_order
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;

export const UPDATE_PROGRAM_REGION = `
  mutation updateProgramRegion($input: UpdateProgramRegionInput!, $tenant_id: Int!) {
    updateProgramRegion(input: $input, tenant_id: $tenant_id) {
      name
      region_order
      its
      uts
      dts
      created_by
      updated_by
      deleted_by
    }
  }
`;

export const DELETE_PROGRAM_REGION = `
  mutation deleteProgramRegion($id: Int!, $tenant_id: Int!) {
    deleteProgramRegion(id: $id, tenant_id: $tenant_id) {
      id
    }
  }
`;
